import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { SignContractModalComponent } from './sign-contract-modal';

export const SignContractModalModule: string = ng
    .module('sign-contract-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('signContractModalComponent', SignContractModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/sign-contract-modal/sign-contract-modal.module.ts